import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as widgetSharedStyles } from '../../../assets/widget-shared.scss';
import { FontSizes } from "../../../types/common/types";

export const templateMaintenanceWindowPreviewPatchManagement = document.createElement('template');

templateMaintenanceWindowPreviewPatchManagement.innerHTML = `
  <style>${widgetSharedStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">

    <div class="loaded-content">

      <gz-title id="title" fontsize="18"></gz-title>

      <gz-text id="title-maintenance-details" fontsize="11"></gz-text>
      <div class="details-container">
        <gz-labeled-content id="operations-targeted" label="" hasColon="true" labelFontSize="12">
          <gz-text fontsize="12"></gz-text>
        </gz-labeled-content>

        <gz-labeled-content id="patch-scope" label="" hasColon="true" labelFontSize="12">
          <gz-text fontsize="12"></gz-text>
        </gz-labeled-content>

        <gz-labeled-content id="recurrence" label="" hasColon="true" labelFontSize="12">
          <gz-text fontsize="12"></gz-text>
        </gz-labeled-content>

        <gz-labeled-content id="reboot" label="" hasColon="true">
          <gz-text fontsize="12"></gz-text>
        </gz-labeled-content>
      </div>

    </div>

    <gz-progress-spinner indeterminate spinnerwidth="large"></gz-progress-spinner>
    <gz-image-repo state="error"><gz-title fontweight="500" fontSize='${FontSizes.HEADING_4}'></gz-title>

  </div>
`;
